import AuthConfirm from "../../components/security/auth/authConfirm.container";

const AuthConfirmPage = () => {
  return <AuthConfirm></AuthConfirm>;
};

export default AuthConfirmPage;
